import { type ReactNode, useEffect, useRef } from 'react';

import { i18next } from '@treneo/shared/i18n';

import { useSelectUserLanguage } from '../data';

type Props = {
  children: ReactNode;
};

export const LanguageSync = ({ children }: Readonly<Props>) => {
  const language = useSelectUserLanguage();
  const prevLanguageRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!language) {
      return;
    }
    if (language === prevLanguageRef.current) {
      return;
    }
    if (i18next.language === language) {
      prevLanguageRef.current = language;
      return;
    }
    prevLanguageRef.current = language;
    void i18next.changeLanguage(language);
  }, [language]);

  return <>{children}</>;
};
